const initialState = {
  studyMessage: null,
  success: null,
  states: {},
}

const study = (state = initialState, action) => {
  switch (action.type) {

    case 'SET_STUDY_RESPONSE':
      return {
        ...state,
        studyMessage: action.studyResponse.message,
        success: action.studyResponse.success,
        updateResponse:false
      }

      case 'SET_STUDY_MSG_NULL':
        return {
          ...state,
          studyMessage: null,
          success: null,
          updateResponse:false
        }

        case 'SET_STUDY_LIST':
        return {
          ...state,
          studies: action.data.studyList,
          success: action.data.success,
          showStudyList: true,
          showEditStudy: false,
          updateResponse:false
        }
  
        case 'SET_STUDY_LIST_FAIL':
          return {
            ...state,
            showStudyList: true,
            showEditStudy: false,
            studyMessage: action.data.message,
            success: action.data.success,
            updateResponse:false
          } 

        case 'EDIT_STUDY':  
          return {
            ...state,
            studies: false,
            editStudyData: action.data,
            showStudyList: false,
            showEditStudy: true,
            updateResponse:false
          } 

          case 'SET_UPDATE_STUDY_RESPONSE':
          return {
            ...state,
            updateResponse: action.studyResponse.message,
            showStudyList: false,
            showEditStudy: true,
          } 

          case 'SET_INVITES_DATA':
          return{
            ...state,
            showInvitesData: true,
            invitesDataResponse: action.data.invitesList
          }
          case 'SET_OFF_INVITES_DATA':
          return{
            ...state,
            showInvitesData: false,
          }
 
    default:
      return state;
  }
};
export default study;



// WEBPACK FOOTER //
// ./src/reducers/study.js